import { css } from '@compiled/react';

import { TemplateType } from '@/content/templates/template.types';

import { UniformTemplatePreviewWindow } from './template-preview-window';

interface DeliveryApiImage {
	title: string;
	description: string;
	file: {
		url: string;
		details: {
			size: number;
			image: {
				width: number;
				height: number;
			};
		};
		fileName: string;
		contentType: string;
	};
}

export interface UniformTemplatePreviewProps {
	templatePreview: DeliveryApiImage;
	templateType?: TemplateType;
}

const UniformTemplatePreview = ({ templatePreview, templateType }: UniformTemplatePreviewProps) => {
	if (!templatePreview) {
		return null;
	}

	return (
		<section css={[templatePreviewSection]}>
			<UniformTemplatePreviewWindow
				url={templatePreview.file.url ?? ''}
				alt={templatePreview.description ?? ''}
				templateType={templateType || TemplateType.Page}
			/>
		</section>
	);
};

const templatePreviewSection = css({
	textAlign: 'center',
	position: 'relative',
});

export default UniformTemplatePreview;
